export default {
  "b2b.form-switches.typy-zdroju.label": "Typ zdroje",
  "b2b.form-switches.zdroje.label": "Zdroj",
  "b2b.form-switches.produkty.label": "Specifikace služby"
};
